import React, {useCallback, useState} from 'react';
import {List} from '../list/list.tsx';
import {useClickOutside} from '../../support/use_click_outside.ts';
import {classNames} from '../../support/classnames.ts';
import {LocationListItem} from '../location/location_list_item.tsx';
import styles from './hero.module.scss';
import {LocationType} from '../../gql/pwa/graphql.ts';
interface OwnProps {
    name: string;
    locations?: (LocationType | null)[];
    selectedLocationId: number | null | undefined;
    onClick: (value: LocationType | null | undefined) => void;
}

export function HeroSelect({name, locations, selectedLocationId, onClick}: OwnProps) {
    const [isOpen, setIsOpen] = useState(false);

    const ref = React.useRef<HTMLDivElement | null>(null);
    const closeCallback = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);
    useClickOutside(ref, closeCallback);

    const selectableLocations = locations?.filter((location) => location?.id !== selectedLocationId);

    if (selectableLocations && selectableLocations.length > 0) {
        return (
            <div
                className={classNames(styles.hero__select, {
                    [styles.open]: isOpen,
                })}
                onClick={() => setIsOpen(!isOpen)}
                ref={ref}
            >
                <div className={styles.select_toggle}>{name}</div>
                <i className="fa fa-chevron-down" />

                {isOpen && (
                    <div className={styles.select__list}>
                        <List>
                            {selectableLocations?.map((location, key) => (
                                <LocationListItem onClick={onClick} location={location} key={key} />
                            ))}
                        </List>
                    </div>
                )}
            </div>
        );
    } else {
        return (
            <div className={classNames(styles.hero__select, styles.no_pointer)}>
                <div className={styles.select_toggle}>{name}</div>
            </div>
        );
    }
}
